import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ContainerSlider } from './containerSlider'
import { LifeCycle } from '@wix/thunderbolt-symbols'

export const page: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.PageWillMountHandler).to(ContainerSlider)
}

// We can use the public code without addressing changes in the editor because this is relevant only to preview mode (so no changes can be done)
export const editorPage = page
export { scrollInnerContent, scrollInnerContentV2 } from './utils'
